import React, { useEffect, useState, useRef } from "react"
import PropTypes from "prop-types"
import { withTranslation } from "react-i18next"
import { getTrackerList } from "helpers/backend_helper"
import { Select, ConfigProvider } from "antd"
import { Col, Row } from "reactstrap"
const { Option } = Select;

const SelectTracker = props => {
  const [options, setOptions] = useState([])
  const [loading, setLoading] = useState(false)
  const [searchString, setSearchString] = useState("")

  const abortRef = useRef(null)
  useEffect(() => {
    abortRef.current = new AbortController()
    return () => abortRef.current.abort()
  }, [])

  // Get trackers for dropdown
  const getData = () => {
    setLoading(true)
    getTrackerList(abortRef.current).then(data => {
      if (data.array != null) {
        let opts = []
        for (const group of data.array) {
          group.trackers.sort((a, b) => (a.name > b.name ? 1 : -1))
          for (const tracker of group.trackers) {
            let trackerObject = new Object()
            trackerObject.label = tracker.name
            trackerObject.value = tracker.id
            trackerObject.gsm = tracker.gsm ? tracker.gsm : ""
            trackerObject.imei = tracker.imei ? tracker.imei : ""
            trackerObject.imsi = tracker.imsi ? tracker.imsi : ""
            trackerObject.iccid = tracker.iccid ? tracker.iccid : ""
            trackerObject.serial = tracker.serial ? tracker.serial : ""
            trackerObject.type = tracker.type ? tracker.type : ""
            opts.push(trackerObject)
          }
        }
        opts.sort((a,b) => a.label.localeCompare(b.label))
        setOptions(opts)
      }
    })
      .catch(e => {
        console.log(e)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  // Selection changed
  const handleChange = newSelection => {
    if (props.onChange != null) {
      props.onChange(newSelection)
    }
    if (props.onChangeObject != null) {
      if (newSelection == null) {
        props.onChangeObject(null)
      }
      else {
        console.log(newSelection)
        let filtered = options.filter(item => item.value == newSelection)
        props.onChangeObject(filtered.length > 0 ? filtered[0] : null)
      }
    }
  }

  // Custom empty/Data not found dropdown
  const customizeRenderEmpty = () => (
    <div className="mt-3" style={{ textAlign: "center" }}>
      {loading
        ? <p>{props.t("Loading")}</p>
        : <p>{props.t("No entries found")}</p>
      }
    </div>
  )

  // Dropdown visibility, get data at first
  const visibilityChanged = (visible) => {
    if (visible && options.length == 0 && !loading) {
      getData()
    }
  }

  return (
    <div>
      <ConfigProvider renderEmpty={customizeRenderEmpty}>
        <div className="config-provider">
          <Select
            showSearch
            loading={loading}
            onOpenChange={visibilityChanged}
            value={props.selection}
            mode={props.multiple ? "multiple" : null}
            allowClear={props.clearable != null ? props.clearable : true}
            placeholder={props.t("Select tracker")}
            style={{ width: 100 + "%" }}
            onChange={handleChange}
            onSearch={s => { setSearchString(s) }}
            filterOption={(inputValue, option) => {
              return (
                option.label?.toLowerCase().includes(inputValue.toLowerCase()) ||
                option.value?.toLowerCase().includes(inputValue.toLowerCase()) ||
                option.gsm?.toLowerCase().includes(inputValue.toLowerCase()) ||
                option.imei?.toLowerCase().includes(inputValue.toLowerCase()) ||
                option.imsi?.toLowerCase().includes(inputValue.toLowerCase()) || 
                option.serial?.toLowerCase().includes(inputValue.toLowerCase()) 
              );
            }}
          >
            {options.map((tracker, index) => {
              return (
                <Option key={tracker.value} value={tracker.value} label={tracker.label} gsm={tracker.gsm} imsi={tracker.imsi} imei={tracker.imei} serial={tracker.serial}>
                  <Row type="flex" justify="start">
                    <Col className="col-auto">{tracker.label}</Col>
                    {searchString && tracker.gsm?.toLowerCase().includes(searchString) &&
                      <Col className="col-auto"><strong className="text-primary">GSM: </strong>{tracker.gsm}</Col>
                    }
                    {searchString && tracker.imei?.toLowerCase().includes(searchString) &&
                      <Col className="col-auto"><strong className="text-primary">IMEI: </strong>{tracker.imei}</Col>
                    }
                    {searchString && tracker.imsi?.toLowerCase().includes(searchString) &&
                      <Col className="col-auto"><strong className="text-primary">IMSI: </strong>{tracker.imsi}</Col>
                    }
                    {searchString && tracker.serial?.toLowerCase().includes(searchString) &&
                      <Col className="col-auto"><strong className="text-primary">S/N: </strong>{tracker.serial}</Col>
                    }
                    {searchString && tracker.value?.toLowerCase().includes(searchString) &&
                      <Col className="col-auto"><strong className="text-primary">GUID: </strong>{tracker.value}</Col>
                    }
                  </Row>
                </Option>
              )
            })}
          </Select>
        </div>
      </ConfigProvider>
    </div>
  )
}

SelectTracker.propTypes = {
  t: PropTypes.any,
  selection: PropTypes.string,
  onChange: PropTypes.func,
  onChangeObject: PropTypes.func,
  multiple: PropTypes.bool,
  clearable: PropTypes.bool,
}

export default withTranslation()(SelectTracker)